import React from 'react';
import { useSelector } from 'react-redux';

import { selectHighlightedRegions, selectShowFWR } from '../../store/slices/antibodyAnalysis.slice';
import { useGlobalChainWidths } from '../hooks/useGlobalChainWidths';
import type { AntibodyResponse } from '../types';

interface ChainWidths {
  heavy: number;
  light: number;
}

const ChainWidthContext = React.createContext<ChainWidths>({ heavy: 0, light: 0 });

/**
 * Provides the global heavy/light chain column widths to the sequence tables.
 */
export function ChainWidthProvider({ clonotypes, children }: { clonotypes: AntibodyResponse[]; children: React.ReactNode }) {
  const showFWR = useSelector(selectShowFWR);
  const highlightedRegions = useSelector(selectHighlightedRegions);
  const widths = useGlobalChainWidths({ clonotypes, showFWR, highlightedRegions });
  return <ChainWidthContext.Provider value={widths}>{children}</ChainWidthContext.Provider>;
}

export function useChainWidths(): ChainWidths {
  return React.useContext(ChainWidthContext);
}
